import moment from 'moment';

const convertToDayMonth = (value) => {
  if (value) {
    return moment(value).format('D-M-YYYY');
  }
  return null;
};

export default convertToDayMonth;
